import React from 'react'

function StarIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" {...props}>
      <g data-name="Group 57046" transform="translate(-38.15 -176.324)">
        <path
          fill="CurrentColor"
          d="M10.879 0l3.244 6.956 7.6.944-5.6 5.274 1.425 7.552-6.706-3.7-6.719 3.727 1.456-7.558L0 7.943l7.606-.975z"
          data-name="Path 67989"
          transform="translate(39.309 177.565)"
        ></path>
        <path
          fill="#263238"
          d="M12.016 0l3.594 7.723L24 8.767 17.82 14.6l1.58 8.368-7.416-4.1L4.542 23l1.611-8.38L0 8.815l8.39-1.078zm9.751 9.493l-6.846-.853-2.908-6.249-2.934 6.261-6.854.88 5.028 4.743-1.308 6.8 6.033-3.35L18 21.056l-1.281-6.8z"
          data-name="Path 67989 - Outline"
          transform="translate(38.15 176.324)"
        ></path>
      </g>
    </svg>
  )
}

export default StarIcon
